export enum TimeOption {
  // Day = 'Day',
  Month = 'Month',
  // Year = 'Year',
  Current = 'Current',
}
